import axios from 'axios';
import getCurrentLanguage from '../../utils/functions/get-language';

let activeRequests = 0;

const customerApi = axios.create({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'x-device': window?.ReactNativeWebView ? 'app' : 'web',
  },
});

const updateLoadingIndicator = () => {
  if (activeRequests === 0) {
    setTimeout(() => {
      // Check again to ensure no active requests during the delay
      if (activeRequests === 0) {
        document.body.classList.remove('loading-indicator');
      }
    }, 300);
  }
};

customerApi.interceptors.request.use((req) => {
  if (activeRequests === 0) {
    document.body.classList.add('loading-indicator');
  }
  activeRequests += 1;

  if (
    typeof window !== 'undefined'
    && window.localStorage.getItem('accessToken')
  ) {
    req.headers.authorization = `Bearer ${window.localStorage.getItem(
      'accessToken',
    )}`;
  }

  const language = getCurrentLanguage();

  // Ensure the headers object exists
  req.headers = req.headers || {};

  // Set the custom `interface-language` header
  req.headers['interface-language'] = String(language);
  return req;
});

customerApi.interceptors.response.use(
  (response) => {
    if (activeRequests > 0) {
      activeRequests -= 1;
    }
    updateLoadingIndicator();

    return response;
  },
  (error) => {
    if (activeRequests > 0) {
      activeRequests -= 1;
    }

    updateLoadingIndicator();
    return Promise.reject(error);
  },
);

export default customerApi;
